import React from 'react';
import classNames from 'classnames';

const stateToColor: Record<string, string> = {
    cancelled: 'text-gray-400 bg-gray-400/10',
    completed: 'text-teal-500 bg-teal-500/10',
    error: 'text-red-400 bg-red-400/10',
    in_progress: 'text-blue-400 bg-blue-400/10',
};

interface IProps {
    state: string;
}

export default function StatusDot(props: IProps) {
    const { state } = props;

    if (state === 'in_progress') {
        return (
            <div className='flex-none rounded-full p-1'>
                <span className='relative flex h-2 w-2'>
                    <span className='animate-ping absolute inline-flex h-full w-full rounded-full bg-sky-400 opacity-75' />
                    <span className='relative inline-flex rounded-full h-2 w-2 bg-sky-500' />
                </span>
            </div>
        );
    }

    return (
        <div className={classNames(stateToColor[state] ?? stateToColor.cancelled, 'flex-none rounded-full p-1')}>
            <div className='h-2 w-2 rounded-full bg-current' />
        </div>
    );
}
